import { render, staticRenderFns } from "./GastosGenerales.vue?vue&type=template&id=32468793&scoped=true&"
import script from "./GastosGenerales.vue?vue&type=script&lang=js&"
export * from "./GastosGenerales.vue?vue&type=script&lang=js&"
import style0 from "./GastosGenerales.vue?vue&type=style&index=0&id=32468793&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32468793",
  null
  
)

export default component.exports